import { useContext, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardContext from "../context/DashboardContext";
import InputMask from "react-input-mask";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import CustomTextField from "../components/CustomTextField";
import EditIcon from "@mui/icons-material/Edit";
// import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import { newWorker } from "../services";
import { useNavigate } from "react-router-dom";
export default function NewWorker() {
  // VALORES INICIAIS DOS ESTADOS
  const { clientId, token, clientUser, clientPassword, typeClient, permissions, totalWorkers } = useContext(DashboardContext);

  const UNLIMITED_WORKERS = permissions?.unlimitedWorkers !== undefined ? permissions.unlimitedWorkers : true;
  const MAX_WORKERS_NUM = permissions?.maxWorkers || 0;

  const INITIAL_INPUTS_VALUE = {
    name: "",
    password: "",
    cpf: "",
    admin: "",
    id_empresa: Number(clientId),
  };

  // ESTADOS DA APLICAÇÃO

  const [formInputs, setFormInputs] = useState(INITIAL_INPUTS_VALUE);

  const navigation = useNavigate();

  // HANDLERS

  // ----- inputs do formulário
  const handleTextInputsChange = ({ target: { name, value } }) => {
    setFormInputs((prevState) => ({ ...prevState, [name]: value }));
  };

  // ----- submit do formulário
  const submitNewMember = async (event) => {
    event.preventDefault();
    console.log('Unlimit: ', UNLIMITED_WORKERS, 'Total: ', totalWorkers, 'Max: ', MAX_WORKERS_NUM);
    if (!UNLIMITED_WORKERS) {
      if (totalWorkers >= MAX_WORKERS_NUM) {
        return toast.error("Limite de Funcionários atingido!!");
      }
    };
    const sendData = { body: formInputs };
    if (typeClient === "cnpj") {
      sendData.user = clientUser;
      sendData.password = clientPassword;
    } else {
      sendData.token = token;
    }
    const response = await newWorker(sendData);
    if (!response) {
      toast.error(
        "Erro ao cadastrar Funcionário , Tentar novamente mais tarde "
      );
    } else {
      setFormInputs(INITIAL_INPUTS_VALUE);
      toast.success("Funcionário Cadastrado com Sucesso!! 😃");
      navigation("/workers");
    }
  };

  // RETORNO

  return (
    <Container>
      {/* CONTAINER PRINCIPAL */}
      <CustomContainer
        style={{ padding: "32px 48px" }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minWidth: 1100,
        }}
      >
        {/* TÍTULO DA PÁGINA */}
        <Typography
          color="primary"
          component="h2"
          mb={4}
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          variant="h4"
        >
          <EditIcon fontSize="md" sx={{ mr: 1 }} />
          Cadastrar Funcionário
        </Typography>

        {/* FORMULÁRIO DE CADASTRO */}
        <form onSubmit={submitNewMember}>
          <Stack spacing={2}>
            {/* PRIMEIRA LINHA */}
            <Stack direction="row" spacing={2}>
              {/* NOME */}
              <CustomTextField
                autoComplete="off"
                color="primary"
                label="Nome"
                name="name"
                onChange={handleTextInputsChange}
                required
                size="small"
                // sx={{ width: "30%" }}
                sx={{ width: "40%" }}
                type="text"
                value={formInputs.nome}
                variant="outlined"
              />

              {/* CPF/CNPJ/MATRÍCULA */}

              <InputMask
                mask="999.999.999-99"
                disabled={false}
                maskChar=" "
                onChange={handleTextInputsChange}
                required
                value={formInputs.cpf}
              >
                {() => (
                  <CustomTextField
                    name="cpf"
                    autoComplete="off"
                    color="primary"
                    label="CPF *"
                    size="small"
                    // sx={{ width: "30%" }}
                    sx={{ width: "40%" }}
                    variant="outlined"
                    type="text"
                  />
                )}
              </InputMask>
              <CustomTextField
                autoComplete="off"
                color="primary"
                label="Senha"
                name="password"
                onChange={handleTextInputsChange}
                required
                size="small"
                // sx={{ width: "30%" }}
                sx={{ width: "40%" }}
                type="password"
                value={formInputs.senha}
                variant="outlined"
              />
              <CustomTextField
                color="primary"
                label="Acesso"
                name="admin"
                onChange={handleTextInputsChange}
                select
                size="small"
                sx={{ width: "341.33px" }}
                value={formInputs.admin}
                variant="outlined"
              >
                <MenuItem disabled value=""></MenuItem>
                <MenuItem value={2}>Administrador</MenuItem>
                <MenuItem value={1}>Técnico</MenuItem>
                <MenuItem value={0}>Colaborador</MenuItem>
              </CustomTextField>

              {/* CARTÃO */}
              {/* <CustomTextField
                color="primary"
                label="Cartão"
                name="cartao"
                onChange={ handleTextInputsChange }
                required
                select
                size="small"
                sx={{ width: "20%" }}
                value={ formInputs.cartao }
                variant="outlined"
              >
                <MenuItem disabled value=""></MenuItem>
                <MenuItem value="1">Imprimir</MenuItem>
                <MenuItem value="0">Não Imprimir</MenuItem>
              </CustomTextField> */}

              {/* CORTESIA */}
              {/* <CustomTextField
                color="primary"
                label="Cortesia"
                name="cortesia"
                onChange={ handleTextInputsChange }
                required
                select
                size="small"
                sx={{ width: "20%" }}
                value={ formInputs.cortesia }
                variant="outlined"
              >
                <MenuItem disabled value=""></MenuItem>
                <MenuItem value="0">Não</MenuItem>
                <MenuItem value="1">Sim</MenuItem>
              </CustomTextField> */}
            </Stack>

            {/* BOTÃO DE SUBMIT */}
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
            >
              <CustomButton
                sx={{ width: "200px" }}
                type="submit"
                variant="contained"
              >
                Cadastrar
              </CustomButton>
            </Box>
          </Stack>
        </form>
      </CustomContainer>
    </Container>
  );
}
